import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-brand-slate p-8" data-testid="error-boundary">
          <div className="max-w-md border border-brand-cyan/30 bg-brand-card p-8 text-center">
            <p className="font-display text-2xl font-bold uppercase text-white">Ops, qualcosa è andato storto</p>
            <p className="mt-3 text-sm text-slate-400">Ricarica la pagina per continuare la navigazione.</p>
            <button
              data-testid="error-boundary-reload"
              onClick={() => window.location.reload()}
              className="mt-6 bg-brand-cyan px-6 py-2.5 font-mono text-xs uppercase tracking-[0.2em] text-brand-teal transition hover:bg-brand-ice"
            >
              Ricarica
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
